export const appVersion = 'v3.6.10';
